import React, { useState, useEffect } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { leaveApi } from '../lib/api';
// ONE icon map for the whole app — see lib/leaveTypeIcons (Rob, 16 Jul).
import { LEAVE_TYPE_ICONS as leaveTypeIcons } from '../lib/leaveTypeIcons';
import { iconOn } from '../lib/leaveColour';

const QuickBookPopover = ({ children, date, onSelectLeaveType, disabled }) => {
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && leaveTypes.length === 0) {
      fetchLeaveTypes();
    }
  // Keyed on `open` alone on purpose: this is the fetch-on-open. Re-running as leaveTypes fills would do nothing.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const fetchLeaveTypes = async () => {
    setLoading(true);
    try {
      const response = await leaveApi.getTypes();
      // Filter to only bookable leave types (exclude system types if any)
      setLeaveTypes(response.data.filter(t => t.is_active !== false));
    } catch (error) {
      console.error('Failed to fetch leave types:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = (leaveType) => {
    setOpen(false);
    onSelectLeaveType(date, leaveType);
  };

  const getIcon = (iconName) => {
    const IconComponent = leaveTypeIcons[iconName?.toLowerCase()] || leaveTypeIcons.calendar;
    return IconComponent;
  };

  if (disabled) {
    return children;
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        {children}
      </PopoverTrigger>
      <PopoverContent className="w-48 p-2" align="start">
        <p className="text-xs font-medium text-muted-foreground mb-2 px-1">Quick book</p>
        {loading ? (
          <div className="text-center py-2 text-sm text-muted-foreground">Loading...</div>
        ) : (
          <div className="space-y-1">
            {leaveTypes.map((type) => {
              const Icon = getIcon(type.icon);
              return (
                <button
                  key={type.id}
                  onClick={() => handleSelect(type)}
                  className="w-full flex items-center gap-2 px-2 py-1.5 rounded hover:bg-secondary transition-colors text-left"
                >
                  <div 
                    className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: type.color }}
                  >
                    <Icon className={`w-3.5 h-3.5 ${iconOn(type.color)}`} />
                  </div>
                  <span className="text-sm truncate">{type.name}</span>
                </button>
              );
            })}
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
};

export default QuickBookPopover;
